module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"label":"어떤 사이즈가 잘 맞을지 고민되나요? {link} AI 추천 사이즈를 확인해 보세요!","label_link":"여기를 클릭해"}}')
  delete Component.options._Ctor
}
